import appEventData from "./appEventData";

export enum LoginEventName {
  LoginComplete = "Login Complete",
  LoginFailure = "Login Failure",
  LoginLockout = "Login Lockout",
  LoginStarted = "Login Started",
  LoginStep = "Login Step",
}

export type LoginEvent = {
  eventName: LoginEventName;
  loginMethod: string;
  processStepLabel: string;
  processStepValue: string;
  siteLoginStatus: string;
};

const loginEvent = (loginEvent: LoginEvent) => {
  appEventData.push({
    event: loginEvent.eventName,
    process: {
      processStepLabel: loginEvent.processStepLabel,
      processStepValue: loginEvent.processStepValue,
    },
    userStatus: {
      loginMethod: loginEvent.loginMethod,
      siteLoginStatus: loginEvent.siteLoginStatus,
    },
  });
};

export default loginEvent;
